module.exports = __webpack_public_path__ + "static/media/Hydragenum.34094973.svg";